<template>
  <div :class="'stage stage-default ' + stage.heading">
    <h1
      v-if="stage.heading"
      class="stage-heading"
      v-html="stage.heading"
    ></h1>

    <ButtonGroup
      v-if="stage.options"
      ref="button-group"
      :buttons="stage.options"
      @action="onAction"
    />

    <ButtonMedicalRecords v-if="stage['records-button']" @action="onAction" />

    <BasePopup
      v-if="activePopup"
      :popup="activePopup"
      @action="onAction"
    />

    <BasePopup
      v-if="definitionPopup"
      :popup="definitionPopup"
      @action="onAction"
    />
  </div>
</template>

<script>
import BasePopup from '../popups/BasePopup.vue'
import ButtonGroup from '../partials/ButtonGroup.vue'
import ButtonMedicalRecords from '../partials/ButtonMedicalRecords.vue'

export default {
  name: 'StageDefault',
  components: {
    BasePopup,
    ButtonGroup,
    ButtonMedicalRecords,
  },
  props: {
    stage: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      activePopup: null,
      definitionPopup: null,

      eventHandlers: {
        'goto-stage': this.gotoStage,
        'reset-score': this.resetScore,
        'show-records': this.showRecords,
        'show-popup': this.showPopup,
        'close-popup': this.hidePopup,
        'show-definition-popup': this.showDefinitionPopup,
        'close-definition-popup': this.hideDefinitionPopup,
      },
    }
  },
  methods: {
    onAction(event) {
      if (event.type in this.eventHandlers) {
        this.eventHandlers[event.type](event);
      } else {
        this.$emit('action', event);
      }
    },
    gotoStage(event) {
      this.$emit('action', event);
    },
    showRecords(event) {
      this.$emit('action', event);
    },
    showPopup(event) {
      this.definitionPopup = null;
      this.activePopup = this.stage.popups[event.popup] || null;
    },
    hidePopup() {
      this.activePopup = null;
    },
    showDefinitionPopup(event) {
      this.activePopup = null;
      this.definitionPopup = this.stage.popups[event.popup] || null;
    },
    hideDefinitionPopup() {
      this.definitionPopup = null;
    },
    resetScore() {
      this.$store.commit('resetScore');
      this.$store.commit('resetSections');
      this.$emit('action', { type: 'goto-stage', target: 7 });
    },
  },
  mounted() {
    if (this.stage.onload) {
      this.onAction(this.stage.onload);
    }
  },
}
</script>
